import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { InputOtpModule } from 'primeng/inputotp';
import { PasswordModule } from 'primeng/password';
import { DialogModule } from 'primeng/dialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { AuthRegisterAuthCodeComponent } from './pages/register-auth-code/auth-register-auth-code.component';
import { AuthOtpInputComponent } from './components/otp-input/auth-otp-input.component';
import { AuthLoginComponent } from './pages/login/auth-login.component';
import { AuthResetPasswordComponent } from './pages/reset-password/auth-reset-password.component';
import { OAuthLoadingComponent } from './pages/oauth-loading/oauth-loading.component';
import { $rootScopeProvider } from '../../ajs-upgraded-providers';

@NgModule({
    imports: [
        SharedModule,
        InputOtpModule,
        PasswordModule,
        DialogModule,
        InputGroupModule,
        InputGroupAddonModule
    ],
    providers: [
        $rootScopeProvider
    ],
    declarations: [
        AuthRegisterAuthCodeComponent,
        AuthOtpInputComponent,
        AuthLoginComponent,
        AuthResetPasswordComponent,
        OAuthLoadingComponent
    ],
    exports: [
        AuthRegisterAuthCodeComponent,
        AuthOtpInputComponent,
        AuthLoginComponent,
        AuthResetPasswordComponent,
        OAuthLoadingComponent
    ]
})
export class AuthModule {}
